<template>
	<div class="animated-check ms-2" aria-label="Success" role="img" :style="{ width: size, height: size }">
		<svg viewBox="0 0 100 100">
			<!-- ring -->
			<circle class="ring" cx="50" cy="50" r="38" />

			<!-- check -->
			<path class="check" d="M30 52 L45 67 L73 39" />

			<!-- sparkles -->
			<g class="sparkles">
			<circle cx="18" cy="50" r="2" />
			<circle cx="82" cy="50" r="2" />
			<circle cx="50" cy="18" r="2" />
			<circle cx="50" cy="82" r="2" />
			</g>
		</svg>
	</div>
</template>
<script>
export default {
	props: {
		size: {
			type: String,
			default: '30px'
		}
	},
}
</script>
<style scoped>
/*styles for animated check*/
.animated-check {
  --success: #4CAF50;
  --stroke: 8;
  --check-stroke: 9;
  display: inline-block;
}

.animated-check svg {
  width: 100%;
  height: 100%;
  overflow: visible;
}

/* base styles */
.ring,
.check {
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.ring {
  stroke: var(--success);
  stroke-width: var(--stroke);
  /* draw animation setup */
  stroke-dasharray: 238;
  stroke-dashoffset: 238;
  animation: ring-draw 500ms ease-out forwards;
}

.check {
  stroke: var(--success);
  stroke-width: var(--check-stroke);
  /* draw animation setup */
  stroke-dasharray: 60;
  stroke-dashoffset: 60;
  animation: check-draw 300ms 200ms ease-out forwards;
}

/* subtle pop once the check completes */
.animated-check svg {
  transform-origin: 50% 50%;
  animation: pop 300ms 500ms ease-out both;
}

.sparkles {
  fill: var(--success);
  opacity: 0;
  transform-origin: 50% 50%;
  animation: sparkle 350ms 650ms ease-out forwards;
}

/* keyframes */
@keyframes ring-draw {
  to { stroke-dashoffset: 0; }
}

@keyframes check-draw {
  to { stroke-dashoffset: 0; }
}

@keyframes pop {
  0%   { transform: scale(0.94); }
  60%  { transform: scale(1.08); }
  100% { transform: scale(1); }
}

@keyframes sparkle {
  0%   { opacity: 0; transform: scale(0.6); }
  60%  { opacity: 1; transform: scale(1.1); }
  100% { opacity: 0; transform: scale(1); }
}

/* accessibility: respect reduced motion */
@media (prefers-reduced-motion: reduce) {
  .ring, .check, .sparkles, .animated-check svg {
    animation: none !important;
    stroke-dashoffset: 0 !important;
    opacity: 1 !important;
    transform: none !important;
  }
}
</style>